import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidOtherSellerRoleError extends Violation {
	public constructor() {
		super(ViolationSeverity.Error, 'business.company.validation.other-seller.role-relative-to-other-seller-required');
	}
}
